import mutations from './invoiceTreatment.mutations'
import actions from './invoiceTreatment.actions'
import getters from './invoiceTreatment.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
